module.exports = __webpack_public_path__ + "img/1511317674.407e8be7.jpg";